// Translation: Utility > Loading error (Turkish)
export default Object.freeze({
	description: '',
	title: ''
})
